import { styled, Typography } from '@mui/material';

export const SubMenuTitle = styled(Typography)({
  fontSize: 18,
  fontWeight: 700,
  textTransform: 'uppercase',
});
